import { getCompaniesSchema } from '@/types/schemas/companies/getCompanies';
import {
  companySiteDefaultSchema,
  getCompanySitesSchema,
} from '@/types/schemas/companies/getCompanySites';
import { axios } from './axiosClient';
import { validate } from '@/utils/errors/helpers';
import type { Company, CompanySite } from '@/types/Companies';

export async function getCompanies(): Promise<Company[]> {
  const response = await axios.get('v2/traders/companies');

  return validate(getCompaniesSchema, response.data.data);
}

export async function getCompanySites(): Promise<CompanySite[]> {
  const response = await axios.get('v2/traders/company-sites');

  return validate(getCompanySitesSchema, response.data.data);
}

export async function getCompanySitesByUserId(userId: string): Promise<CompanySite[]> {
  const response = await axios.get(`v2/traders/user-company-sites/${userId}`);

  return validate(getCompanySitesSchema, response.data.data);
}

export async function getDefaultCompanySite(): Promise<CompanySite | null> {
  const response = await axios.get('v2/traders/company-sites/get-default', {
    validateStatus: (status: number) => status === 404 || status === 200,
  });

  if (response.status === 404) return null;

  return validate(companySiteDefaultSchema, response.data.data);
}
